export default {"src":"/_next/static/media/celebrities.bf7af6e5.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};